import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './WhatWeDo.css';

// Import images
import img1 from '../../Assets/Services/img (1).png';
import img2 from '../../Assets/Services/img (2).png';
import img3 from '../../Assets/Services/img (3).png';
import img4 from '../../Assets/Services/img (4).png';
import img5 from '../../Assets/Services/img (5).png';
import img6 from '../../Assets/Services/img (6).png';

const serviceData = [
  { id: 1, title: 'Insulation Services', img: img1 },
  { id: 2, title: 'Installation Services', img: img2 },
  { id: 3, title: 'Nitrile Rubber Sheet', img: img3 },
  { id: 4, title: 'Industrial Ducting Services', img: img4 },
  { id: 5, title: 'Insulation Roll', img: img5 },
  { id: 6, title: 'New Items', img: img6 },
];

const Services = () => {
  const [activeId, setActiveId] = useState(1);

  return (
    <section className="services-section">
      <div className="services-header">
        <h2>What We Do?</h2>
        <p>
          We deliver advanced insulation materials and ducting solutions that
          enhance thermal control, minimize energy loss, and improve operational efficiency.
        </p>
      </div>

      <div className="services-container">
        {/* LEFT: Service List Section */}
        <div className="services-list">
          {serviceData.map((service) => (
            <div
              key={service.id}
              className={`service-item ${activeId === service.id ? 'active' : ''}`}
              onMouseEnter={() => setActiveId(service.id)}
            >
              <div className="service-text-row">
                <h3>{service.title}</h3>
                <span className="service-arrow">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </div>
              
              {/* Base grey line (low opacity) */}
              <div className="underline-base">
                {/* Active orange line draws across */}
                <AnimatePresence>
                  {activeId === service.id && (
                    <motion.div 
                      className="underline-active"
                      initial={{ width: 0 }}
                      animate={{ width: '100%' }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.5, ease: "circOut" }}
                    />
                  )}
                </AnimatePresence>
              </div>
            </div>
          ))}
        </div>

        {/* RIGHT: Image Display Section */}
        <div className="services-image-display">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeId}
              className="image-wrapper"
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -30 }}
              transition={{ duration: 0.4, ease: "easeOut" }}
            >
              <img
                src={serviceData.find(s => s.id === activeId).img}
                alt="Service Detail"
              />
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default Services;